var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveCustomer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40.4995,
    r: 40.5,
    fill: "#EAC8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.7066 35.1588V30.2649C55.7066 29.9404 55.5747 29.6292 55.3398 29.3997C55.1049 29.1703 54.7863 29.0414 54.4541 29.0414H29.4025C29.0703 29.0414 28.7517 29.1703 28.5168 29.3997C28.2819 29.6292 28.1499 29.9404 28.1499 30.2649V35.1588H55.7066Z",
    fill: "#650A9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4805 55.6359H53.4567C53.9663 55.6359 54.4549 55.5057 54.8152 55.2738C55.1755 55.0419 55.378 54.7275 55.378 54.3995V37.0905H28.4805V55.6359Z",
    fill: "#650A9D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCustomer);
export default __webpack_public_path__ + "static/media/activeCustomer.e0437422138f9c23eb8731333c94abc4.svg";
export { ForwardRef as ReactComponent };